/**
 * A school's initials, for the seal every illustration falls back to when there is no logo.
 *
 * Shared so the three frames that draw a school mark cannot disagree about how a name is shortened —
 * a preview whose fallback differs from its neighbour's is a preview nobody trusts.
 */
export const schoolInitials = (schoolName: string): string => schoolName
  .split(' ')
  .filter(Boolean)
  .slice(0, 2)
  .map(part => part[0].toUpperCase())
  .join('');
